import { memo, type FC } from "react";
import { useTranslation } from "react-i18next";
import AudienceListSelect from "src/components/reusable/AudienceListSelect/AudienceListSelect";
import CampaignFormField from "../../../shared/CampaignFormField";
import CampaignTextField from "../../../shared/CampaignTextField";
import { getFieldErrorId, useRequiredFieldError } from "../../../shared/UseRequiredFieldError";
import { useAudienceListsAndCompany } from "../../../CampaignSetup/UseAudienceListsAndCompany";

const NAME_FIELD_ID = "wa-campaign-name";
const SEND_TO_FIELD_ID = "wa-campaign-send-to";
const POPUP_CLASS = "campaign-flow__popup";

interface WhatsAppCampaignDetailsFieldsProps {
  campaignName: string;
  sendTo: string[];
  onCampaignNameChange: (_value: string) => void;
  onSendToChange: (_value: string[]) => void;
}

const WhatsAppCampaignDetailsFields: FC<WhatsAppCampaignDetailsFieldsProps> = ({
  campaignName,
  sendTo,
  onCampaignNameChange,
  onSendToChange,
}) => {
  const { t } = useTranslation();
  const { audienceOptions, isListsLoading } = useAudienceListsAndCompany();
  const sendToField = useRequiredFieldError(sendTo, true);

  return (
    <div className="campaign-flow__field-row">
      <CampaignTextField
        id={NAME_FIELD_ID}
        label={t("campaignFlow.aiWizard.details.campaignName")}
        value={campaignName}
        onChange={onCampaignNameChange}
        placeholder={t("campaignFlow.createCampaignNew.campaignNamePlaceholder")}
        required
      />
      <CampaignFormField
        label={t("campaignFlow.createCampaignNew.sendTo")}
        htmlFor={SEND_TO_FIELD_ID}
        required
        hasError={sendToField.hasError}
      >
        <AudienceListSelect
          id={SEND_TO_FIELD_ID}
          value={sendTo}
          options={audienceOptions}
          onChange={onSendToChange}
          onBlur={sendToField.handleBlur}
          aria-invalid={sendToField.hasError}
          aria-describedby={sendToField.hasError ? getFieldErrorId(SEND_TO_FIELD_ID) : undefined}
          loading={isListsLoading}
          placeholder={t("campaignFlow.createCampaignNew.selectAudience")}
          popupClassName={POPUP_CLASS}
          showSelectedIcon
        />
      </CampaignFormField>
    </div>
  );
};

export default memo(WhatsAppCampaignDetailsFields);
